
import makerjs from "makerjs";
function B66(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,R = Param[2].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       l = L * 1 * myZoom,       
       r = R * 1 * myZoom,       
       h = l,
       w = b,
       //拱高计算
      // hd=s1-Math.sqrt(r*r-b*b),
       hd=l-r,bd=b-r,rd=r/Math.sqrt(2),

       x0 = 0, x1 = 0, x2 =r ,x3 =b ,x4 =b, 
       y0 = 0, y1 =hd,y2 =l, y3 =l,y4=0,glassH =l, glassW = w;
       if (b !== 0) {
        var TxtB ="B="+ B;
    }  if (l !== 0) {
     var TxtL = "L="+L;
   }    if (r !== 0) {
     var TxtR = "R="+R;
   }
   console.log("rd=",rd,hd,bd);
   var drawAbnormalShapeB66 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine": new makerjs.paths.Arc([x1, y1], [x2,y2], r,false,true),
        "RightArcLine": new makerjs.paths.Line([x2,y2], [x3,y3]),
        "RightLine": new makerjs.paths.Line([x3,y3], [x4,y4]),
        "BottomLine": new makerjs.paths.Line([x4,y4],[0, 0]),
       }
   };
   var drawAbnormalShapeB66MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, -markShift], [b, -markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, 0], [0, -3*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, 0], [b, -3*markShift]),
       }  
   };
   var drawAbnormalShapeB66MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x3+ markShift, y3]),
        "RightShortUpline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
        "RightShortDnline": new makerjs.paths.Line([x4, y4], [x4+ 2 * markShift, y4]),
       }
   };
   var drawAbnormalShapeB66MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([r, hd], [r-rd, hd+rd]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeB66MarkB, TxtB,  [0,-2*markShift], [b, -2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB66MarkL, TxtL, [x4+ 3*markShift, y4], [x3+ 3*markShift, y3]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB66MarkR, TxtR,  [r-markShift, hd-markShift], [r+2*markShift, hd-markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB66: drawAbnormalShapeB66,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB66: drawAbnormalShapeB66,
        drawAbnormalShapeB66MarkB:drawAbnormalShapeB66MarkB,
        drawAbnormalShapeB66MarkL:drawAbnormalShapeB66MarkL,
        drawAbnormalShapeB66MarkR:drawAbnormalShapeB66MarkR,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B66;